<template>
    <Card :title="$t('labels.edit_user')">
        <div class="card-body">
            <form @submit.prevent="createProjectUser">
                <FormGroup :label="$t('labels.email')">
                    <Input v-model="email" />
                </FormGroup>
            </form>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="createProjectUser" type="submit">
                {{ $t('buttons.create') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';

import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: "CreateProjectUsersPage",
    components: {
        Card, FormGroup, Input, AppButton
    },
    data() {
        return {
            email: ''
        };
    },
    methods: {
        createProjectUser() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/users`, {
                email: this.email
            }).then(() => {
                this.$router.replace({ name: 'IndexProjectUsersPage' });
            });
        }
    }
}
</script>